import { Component } from '@angular/core';

@Component({
  selector: 'app-pmu',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent {
  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }
}


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
